import { Box, Grid, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../widgets';
import BotonComponent from '../dashboard/components/BotonNuevo';
import { allPermisosAction, setActivoPermisosAction } from './PermisosAction';
import FormPermisos from './components/FormPermisos';
import ListadoPermisos from './components/ListadoPermisos';

const PermisosView = () => {
  const dispatch = Redux.useDispatch();

  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const usuEntPerfilesStore = Redux.useSelector(
    (state) => state.usuEntPerfiles,
  );
  const permisosStore = Redux.useSelector((state) => state.permisos);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <BotonComponent
              click={async () => {
                await setActivoPermisosAction(dispatch, null);
                setOpenModalForm(true);
              }}
              green
              mr={2}
              addIcon
            />
            <BotonComponent
              click={async () => {
                await setActivoPermisosAction(dispatch, null);
                await allPermisosAction({ dispatch }, permisosStore.params);
              }}
              disabled={
                permisosStore.all.length === 0 || permisosStore.loadingAll
              }
              white
              refreshIcon
              text={permisosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
            />
          </Box>

          <Typography variant="body1" color="initial">
            <strong>Usuario:</strong>{' '}
            {usuEntidadesStore.activo.usuario.perfil.pnombre}{' '}
            {usuEntidadesStore.activo.usuario.perfil.papellido}
            <label style={{ marginLeft: '30px' }}>
              <strong>Perfil:</strong>{' '}
              {usuEntPerfilesStore.activo.perfil.nombre}
            </label>
          </Typography>
        </Stack>
      </Grid>
      <Grid item md={12}>
        <ListadoPermisos setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <ModalComponent
        id="modalFormPermisos"
        title={`${permisosStore.activo ? 'Editar' : 'Crear'} permiso`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormPermisos setOpenModalForm={(val) => setOpenModalForm(val)} />
      </ModalComponent>
    </Grid>
  );
};

export default PermisosView;
